import { render, staticRenderFns } from "./ClientProjectsEditProposals.vue?vue&type=template&id=2e205893&"
import script from "./ClientProjectsEditProposals.vue?vue&type=script&lang=js&"
export * from "./ClientProjectsEditProposals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports